<template lang="html">
  <div class="service-content fixed-content">
    <filterTab
      :citycode="citycode"
      v-on:doSearch="searchData"
      v-if="showFilter"
    ></filterTab>
    <loadData
      viewName="servicesSkuList"
      :fetchData="storeServices"
      :fetchMethod="getServiceInfo"
      :controlPage="changePage"
      :page="pageIndex"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import filterTab from '@/components/product/filter'
import empty from '@/components/common/empty'

import loadData from '@/components/loadMore'

export default {
  props: {
    showFilter: {
      type: [String, Boolean],
      default: true
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 100,
      firstFetch: true,
      hasErr: false,
      isBottom: false,
      citycode: ''
    }
  },
  created() {
    this.getStore()
    this.getAllCate()
    if (!this.$route.query.categoryId) {
      this.getServiceInfo()
    }
  },
  methods: {
    ...mapMutations(['setServiceTypeList', 'setFilterService']),
    async getStore() {
      const storeCode =
        this.$route.query.entity_id || this.$route.query.storeCode || '8002'
      const json = await this.$store.dispatch('getStoreByCode', { storeCode })
      if (json.code === 1001) {
        this.citycode = `${json.data.city}`
      } else {
        this.citycode = '320100'
      }
    },
    async getAllCate() {
      const json = await this.$store.dispatch('getCategoryList', {})
      // console.log(json)
      if (json && json.length > 0) {
        if (this.$route.query.categoryId) {
          const selected = json.filter(
            v => v.categoryId * 1 === this.$route.query.categoryId * 1
          )
          if (selected && selected.length > 0) {
            const cate = {
              categoryId: selected[0].categoryId,
              categoryName: selected[0].categoryName
            }
            this.setFilterService([cate])
            this.$$title(selected[0].categoryName || '育儿服务')
          } else {
            this.$$title('育儿服务')
          }
        }
        this.setServiceTypeList(json)
      }
    },
    async getServiceInfo() {
      try {
        const storeCode =
          this.$route.query.entity_id || this.$route.query.storeCode
        const param = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          districtId:
            this.serverArea && this.serverArea[0] && this.serverArea[0].ID,
          level4CategoryId:
            this.filterService &&
            this.filterService[0] &&
            this.filterService[0].categoryId,
          isSelf: this.filterSelf - 0,
          businessId:
            this.filterBusiness &&
            this.filterBusiness[0] &&
            this.filterBusiness[0].businessId
        }
        if (storeCode && storeCode !== '') {
          param.storeCode = storeCode
        } else {
          param.storeCode = '8002'
        }
        const serviceData = await this.$store.dispatch(
          'getStoreServices',
          param
        )
        if (serviceData.code * 1 === 1) {
          this.hasErr = false
        } else {
          this.$$toast({
            message: serviceData.msg
          })
          this.hasErr = true
        }
        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    },
    searchData() {
      this.pageIndex = 1
      this.getServiceInfo()
    }
  },
  components: {
    loadData,
    empty,
    filterTab
  },
  computed: {
    ...mapState([
      'storeServices',
      'serverArea',
      'filterService',
      'filterSelf',
      'filterBusiness'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.service-content {
  // padding-top: rem(20px);
  // background: #fff;
  .serve-wrapper {
    display: block;
  }
}
</style>
